export default function isQueryReady(query) {
  return (
    query.loading === false &&
    query.error === undefined &&
    // Will happen when skip === true in the query options.
    query.data !== undefined
  );
}
